// extracted by mini-css-extract-plugin
export var container = "_7r-0";
export var error = "_7r-9";
export var label = "_7r-5";
export var light = "_7r-6";
export var md = "_7r-3";
export var sm = "_7r-2";
export var thin = "_7r-8";
export var thinBold = "_7r-7";
export var vertical = "_7r-4";
export var xs = "_7r-1";